"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Title = function (_a) {
    var children = _a.children, isHidden = _a.isHidden, className = _a.className, style = _a.style;
    if (isHidden)
        return null;
    return react_1.default.createElement(styles_1.default, { className: className || '', style: style }, children);
};
exports.default = Title;
//# sourceMappingURL=index.js.map